<template>
    <div class="theme-search garage-theme">
        <div class="search-field">
            <div class="field-body">
                <div class="field-row">
                    <div class="field">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.chassis" class="input" type="text" placeholder="Chassis">
                            <span class="icon is-small is-left">
                            <i class="fas fa-hashtag"></i>
                        </span>
                        </p>
                    </div>
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.user_details" class="input" type="text" placeholder="Client details">
                            <span class="icon is-small is-left">
                          <i class="fas fa-user"></i>
                        </span>
                        </p>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.country" class="input" type="text" placeholder="Country">
                            <span class="icon is-small is-left">
                          <i class="fas fa-globe"></i>
                        </span>
                        </p>
                    </div>
                    <div class="field" v-if="isAdmin">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.manager" class="input" type="text" placeholder="Manager">
                            <span class="icon is-small is-left">
                          <i class="fas fa-user-shield"></i>
                        </span>
                        </p>
                    </div>
                </div>
                <div class="field-row actions-row">
                    <div class="field">
                        <button class="button is-primary" @click.prevent="handleCarsSearch()">Search</button>
                    </div>
                    <div class="field">
                        <button class="button" @click.prevent="clearForm()">Clear</button>
                    </div>
                </div>
            </div>

        </div>
        <div class="search-field" v-if="isAdmin || isSalesStaff">
            <div class="field-body">
                <div class="field-row">
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.invoice_number" class="input" type="text" placeholder="Inv number">
                            <span class="icon is-small is-left">
                            <i class="fas fa-file-invoice"></i>
                        </span>
                        </p>
                    </div>
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <input v-model="query.shipping_group_id" class="input" type="text"
                                   placeholder="Shipping group Id">
                            <span class="icon is-small is-left">
                            <i class="fas fa-ship"></i>
                        </span>
                        </p>
                    </div>
                </div>
                <div class="field-row">
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <datetime
                                    input-class="input"
                                    v-model="query.lot_date_from"
                                    :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                    type="date"
                                    value-zone="local"
                                    zone="local"
                                    placeholder="Select date from"
                            ></datetime>
                            <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                        </p>
                    </div>
                    <div class="field" v-if="isAdmin || isSalesStaff">
                        <p class="control is-expanded has-icons-left is-fullwidth">
                            <datetime
                                    input-class="input"
                                    v-model="query.lot_date_to"
                                    :format="{ year: 'numeric', month: 'numeric', day: 'numeric'}"
                                    type="date"
                                    value-zone="local"
                                    zone="local"
                                    placeholder="Select date to"
                            ></datetime>
                            <span class="icon is-small is-left">
                      <i class="fas fa-calendar-alt"></i>
                    </span>
                        </p>
                    </div>
                </div>
                <div class="field-row actions-row">
                    <div class="mx-auto">
                        <div class="dropdown is-hoverable" v-if="isAdmin || isSalesStaff">
                            <div class="dropdown-trigger">
                                <button class="button" aria-haspopup="true" aria-controls="dropdown-menu" @click="">
                                    <span>Select Action</span>
                                    <span class="icon is-small">
                                <i class="fas fa-angle-down" aria-hidden="true"></i>
                            </span>
                                </button>
                            </div>
                            <div class="dropdown-menu" id="dropdown-menu" role="menu">
                                <div class="dropdown-content">
                                    <a class="dropdown-item" v-if="isUserSinglePage && !isSalesStaff" @click="createCar">
                                        Create Car
                                    </a>
                                    <a class="dropdown-item" v-if="isUserSinglePage && !isSalesStaff">
                                        Transfer Cars
                                    </a>
                                    <a class="dropdown-item" v-if="isSalesStaff" @click="shippingGroup">
                                        Shipping G roup
                                    </a>
                                    <a class="dropdown-item" @click.prevent="downloadExcel" v-if="!isSalesStaff">
                                        Export
                                    </a>
                                    <a class="dropdown-item" @click.prevent="createMultiproforma" v-if="isAdmin && hasGroupIds">
                                        Create Multiproforma
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import apiUsers from '../../api/apiUsers'
    import apiCars from '../../api/apiCars'
    import apiAuctions from '../../api/apiAuctions'
    import {Datetime} from 'vue-datetime'
    import 'vue-datetime/dist/vue-datetime.css'

    export default {
        components: {
            Datetime
        },
        data() {
            return {
                brands: [],
                auctions: [],
                vessels: [],
                exported_types: [
                    {value: 1, label: 'RORO'},
                    {value: 2, label: 'Container'}
                ]
            }
        },
        methods: {
            clearForm() {
                this.$store.dispatch('clearCarsQuery')
                this.$store.dispatch('fetchCars')
            },
            handleCarsSearch() {
                this.$store.dispatch('fetchCarsWithSearchQuery')
            },
            downloadExcel() {
                this.$store.dispatch('fetchCarsExcelWithSearchQuery')
            },
            createMultiproforma() {
                this.$store.dispatch('setCreateMultiProformaModal', true);
            },
            createCar: function () {
                apiUsers
                    .userRequest(this.$route.params.id)
                    .then((response) => {
                        this.$store.dispatch('setStatusLoaded')
                        this.$store.dispatch('setNewCarUser', response.data)
                        this.$store.dispatch('setNewCarManager', response.data.manager)
                        this.$router.push({name: 'CarCreate'})
                    })
                    .catch((error) => {

                    })
            },
            shippingGroup() {
                this.$store.dispatch('changeShippingGroupModalStatus', true)
                this.$store.dispatch('changeShippingGroupUserId', this.$route.params.id)
            },
            editShippingGroup() {

            }
        },
        computed: {
            query() {
                return this.$store.getters.getCarsQuery
            },
            isUserSinglePage() {
                return location.pathname.split('/')[1] === 'users'
            },
            isAdmin() {
                if (this.$store.getters.getUserRole === 'Admin') {
                    return true
                }
            },
            isSalesStaff() {
                if (this.$store.getters.getUserRole === 'Sales Staff') {
                    return true
                }
            },
            hasGroupIds() {
                if (this.$store.getters.getGroupIds.length) {
                    return true
                }
            }
        },
        created() {
            this.brands = apiAuctions.getCarBrands()
            apiCars
                .carsAuctionsListRequest()
                .then((response) => {
                    this.auctions = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
            apiCars
                .carsVesselsListRequest()
                .then((response) => {
                    this.vessels = response.data
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
</script>

<style scoped>
    .checkbox {
        margin-right: 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Cars/CarsSearch.vue